<template>
    <div class="turn-black">

    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped lang="scss">
    .turn-black {

    }
</style>